export const LEAST = '-1';
export const MOST = '1';
export const TRUE_FALSE = '1';
export const STRONGLY_AGREE = '1';
export const AGREE = '2';
export const NO_OPINION = '3';
export const DISAGREE = '4';
export const STRONGLY_DISAGREE = '5';
